import { RQParam, RQHandlers, RQService, RQApp } from '../../RQuery/RQuery';
import { dmHotel }                               from '../sign-in/xv-hotel';
import { MLText, mlBroker }                      from '../../services/MLText';
import { Icon }                                  from '../../../node_modules/ionic-angular/umd';
import { dmLoading }                             from '../loading/loading';

export class FacilitiesViewModel {
    ShowAlert:       (pTitle: string, pMessage: string) => void;
    BackToSignIn:    ()                                 => void;
    NewLoading:      (pMessage: string)                 => dmLoading;

    mlText:          MLText;
    app:             mlBroker;
    ml:              mlBroker;
    Hotel:           dmHotel;
    LangID:          number;
    InAction:        boolean;

    HotelFacilities: RQService.Ota.GetHotelFacilitiesAllRow[];

    public FaciltyGroup1: any = [];
    public FaciltyGroup2: any = [];
    public FaciltyGroup3: any = [];
    public FaciltyGroup4: any = [];
    public FaciltyGroup5: any = [];

    constructor(
         pMLText:       MLText
        ,pHotel:        dmHotel
        ,pBackToSignIn: ()                                 => void
        ,pShowAlert:    (pTitle: string, pMessage: string) => void
        ,pNewLoading:   (pMessage: string)                 => dmLoading
    ) {
        this.mlText = pMLText;
        this.LangID = this.mlText.GetLangID();
        this.app    = this.mlText.GetBroker(
            'BookingEngineAppTexts'
        );
        this.ml     = this.mlText.GetBroker(
            'HotelAreaFacilities'
        );

        this.Hotel        = pHotel;
        this.BackToSignIn = pBackToSignIn;
        this.ShowAlert    = pShowAlert;
        this.NewLoading   = pNewLoading;

        this.InAction     = false;
        
        this.HotelFacilities = [];

        this.FaciltyGroup1 = [];
        this.FaciltyGroup2 = [];
        this.FaciltyGroup3 = [];
        this.FaciltyGroup4 = [];
        this.FaciltyGroup5 = [];

        this.PopulateHotelFacilities();
    }

    public PopulateHotelFacilities() {
        let loading = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        loading.Show(() => {
            let hotelFacilitiesAllParams     = RQParam.OtaGetHotelFacilitiesAllParams();        
            
            hotelFacilitiesAllParams.HotelID = this.Hotel.HotelID;
            hotelFacilitiesAllParams.LangID  = this.LangID;
            
            RQService.Ota.GetHotelFacilitiesAll(
                hotelFacilitiesAllParams
            ).then((result) => {
                let response = result as any;
            
                if (response.HasErrorOrException) { return; }
                 
                let hotelFacilitiesList = response.RQueryResult;
            
                for (let i = 0; i < hotelFacilitiesList.length; i++) {
                    let hotelFacility = RQService.Ota.PopulateGetHotelFacilitiesAllRow(
                        hotelFacilitiesList[i]
                    );
            
                    this.HotelFacilities.push(hotelFacility);
                } 
                
                loading.Dismiss();
            
                for (let i = 0; i < this.HotelFacilities.length; i++) {
                    if (this.HotelFacilities[i].FacilityGroupID == 1) {
                        this.FaciltyGroup1[this.HotelFacilities[i].FacilityID] = [{
                             "FacilityID":   this.HotelFacilities[i].FacilityID
                            ,"Facility":     this.HotelFacilities[i].Facility
                            ,"FacilityIcon": this.HotelFacilities[i].FacilityIcon
                            ,"IsChecked":    this.HotelFacilities[i].IsChecked
                        }];
                    }
                    if (this.HotelFacilities[i].FacilityGroupID == 2) {
                        this.FaciltyGroup2[this.HotelFacilities[i].FacilityID] = [{
                             "FacilityID":   this.HotelFacilities[i].FacilityID
                            ,"Facility":     this.HotelFacilities[i].Facility
                            ,"FacilityIcon": this.HotelFacilities[i].FacilityIcon
                            ,"IsChecked":    this.HotelFacilities[i].IsChecked
                        }];
                    }
                    if (this.HotelFacilities[i].FacilityGroupID == 3) {
                        this.FaciltyGroup3[this.HotelFacilities[i].FacilityID] = [{
                             "FacilityID":   this.HotelFacilities[i].FacilityID
                            ,"Facility":     this.HotelFacilities[i].Facility
                            ,"FacilityIcon": this.HotelFacilities[i].FacilityIcon
                            ,"IsChecked":    this.HotelFacilities[i].IsChecked
                        }];
                    }
                    if (this.HotelFacilities[i].FacilityGroupID == 4) {
                        this.FaciltyGroup4[this.HotelFacilities[i].FacilityID] = [{
                             "FacilityID":   this.HotelFacilities[i].FacilityID
                            ,"Facility":     this.HotelFacilities[i].Facility
                            ,"FacilityIcon": this.HotelFacilities[i].FacilityIcon
                            ,"IsChecked":    this.HotelFacilities[i].IsChecked
                        }];
                    }
                    if (this.HotelFacilities[i].FacilityGroupID == 5) {
                        this.FaciltyGroup5[this.HotelFacilities[i].FacilityID] = [{
                             "FacilityID":   this.HotelFacilities[i].FacilityID
                            ,"Facility":     this.HotelFacilities[i].Facility
                            ,"FacilityIcon": this.HotelFacilities[i].FacilityIcon
                            ,"IsChecked":    this.HotelFacilities[i].IsChecked
                        }];
                    }
                }
            });
        });
    }

    public SaveFacility(FID :number, Flag: boolean): void {
        if (this.InAction) { return; }

        this.InAction   = true;
        
        let loading     = this.NewLoading(
            this.app.Text('SavingMark', 'Saving...')
        );

        loading.Show(() => {
            let isChecked = 0;
            
            if (Flag == true) { isChecked = 1; }
            
            let saveParams = RQParam.OtaUpdateFacilityParams();
            
            saveParams.HotelID    = this.Hotel.HotelID;
            saveParams.FacilityID = FID;
            saveParams.IsChecked  = isChecked;
            
            RQService.Ota.UpdateFacility(saveParams).then((result) => {
                loading.Dismiss();
            
                this.InAction = false;
            });
        });
    }

    public SignOut(): void {
        this.Hotel.SignOut((pLogOutResult) => { this.BackToSignIn(); });
    }
}


// WEBPACK FOOTER //
// ./src/pages/facilities/xv-facilities.ts